import React from 'react';
import IntroSection from '../components/IntroSection';
import SolutionsSection from '../components/SolutionsSection';
import BlueSectionDivider from '../components/BlueSectionDivider';
import TransformSection from '../components/TransformSection';
import BenefitsSection from '../components/BenefitsSection';
import CountriesSection from '../components/CountriesSection';
import ReimagineSection from '../components/ReimagineSection';
import ProjectsSection from '../components/ProjectsSection';
import TeamSection from '../components/TeamSection';
import WhyUsSection from '../components/WhyUsSection';
import TechStackSection from '../components/TechStackSection';
import FAQSection from '../components/FAQSection';
import ResourcesSection from '../components/ResourcesSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

 // optional if you add styles

const DigitalTransformation = () => {
  return (
    <div>
    <IntroSection title = "DIGITAL TRANSFORMATION" paragraph = "A seamless transformation approach with a smooth and successful transition to the digital realm." backgroundImage="/images/dt-bg.webp"/>
    <SolutionsSection para1 = "Our digital acceleration expertise covers an array of areas, from simpler projects such as web app building to highly complex ML & AI integration." para2 = "Digital Transformation is based on integrating digital technologies, strategies, and innovative approaches into various aspects of a business to change how it operates and delivers value to customers fundamentally.With our digital transformation framework, we guide you through a comprehensive and strategic overhaul of traditional processes, business models, and customer experiences to ensure that your business not only keeps pace but thrives in the rapidly evolving digital landscape."/>
    <BlueSectionDivider/>
    <TransformSection/>
    <BlueSectionDivider/>
    <BenefitsSection/>
    <BlueSectionDivider/>
    <CountriesSection/>
    <BlueSectionDivider/>
    <ReimagineSection/>
    <BlueSectionDivider/>
    <ProjectsSection/>
    <BlueSectionDivider/>
    <TeamSection/>
    <WhyUsSection/>
    <TechStackSection/>
    <BlueSectionDivider/>
    <FAQSection/>
    <BlueSectionDivider/>
   <ContactSection backgroundColor="#057af0ff"/>
    <Footer/>
    
    </div>
  );
};

export default DigitalTransformation;
